export const HUNDRED = 100;

export const STORE = {
	BNN: 'bnn',
	STUDIO_7: 'studio7',
};
